import {
  Box,
  useDisclosure,
  useTheme,
  Text,
  Skeleton,
  useToast,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  Button,
  Flex,
  InputGroup,
  InputRightElement,
  Icon,
} from "@chakra-ui/react";
import React from "react";
import { Theme } from "../../theme";
import getAxios from "../../hooks/useAxios";
import Cookies from "js-cookie";
import Input from "../../components/CustomInput";
import { FaArrowRight, FaTrash } from "react-icons/fa";
import { MdArrowBackIosNew, MdArrowForwardIos, MdSearch } from "react-icons/md";

function Blocked() {
  const theme = useTheme<Theme>();
  const axios = getAxios();
  const access_token = Cookies.get("x-admin-auth");
  const [allDrivers, setAllDrivers] = React.useState<any>([]);
  const [pageNumber, setPageNumber] = React.useState(0);
  const [totalPages, setTotalPages] = React.useState<number>();
  const [totalDrivers, setTotalDrivers] = React.useState<number>();
  const [isDataFetching, setIsDataFetching] = React.useState(true);
  const [nextNotAllowed, setNextNotAllowed] = React.useState(false);
  const [refetchUrl, setRefetchUrl] = React.useState(
    "/drivers?blocked=true&page=1",
  );
  const [searchName, setSearchName] = React.useState("");
  const [searchMobile, setSearchMobile] = React.useState("");
  const [researchData, setResearchData] = React.useState("initial");

  const getAllDrivers = async (url: string) => {
    setIsDataFetching(true);
    try {
      const res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });
      console.log("all drivers", res.data);
      setAllDrivers(res.data.data);
      setTotalPages(res.data.pagination.totalPages);
      setTotalDrivers(res.data.pagination.total);
      if (res.data.length < 20) {
        setNextNotAllowed(true);
      } else {
        setNextNotAllowed(false);
      }
    } catch (error) {
      console.log("error listing drivers", error);
    } finally {
      setIsDataFetching(false);
    }
  };

  const handleSearchData = (val: string) => {
    if (val === "name") {
      if (searchName !== "") {
        getAllDrivers(`/drivers?blocked=true&name=${searchName}`);
      } else {
        getAllDrivers(refetchUrl);
      }
    } else {
      if (searchMobile !== "") {
        getAllDrivers(`/drivers?blocked=true&mobile=${searchMobile}`);
      } else {
        getAllDrivers(refetchUrl);
      }
    }
  };

  React.useEffect(() => {
    getAllDrivers(`/drivers?blocked=true&page=${pageNumber}`);
  }, [pageNumber, researchData]);

  return (
    <Box sx={{ height: "100%", width: "100%", padding: "0 1rem" }}>
      <Text
        sx={{
          fontSize: theme.fontSizes.subHeading1,
          margin: "2.5rem 0 2rem 2rem",
        }}
      >
        Driver Blocked List
      </Text>

      <Flex
        sx={{
          gap: "1rem",
          paddingLeft: "2rem",
          marginBottom: "2rem",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Flex sx={{ gap: "1rem" }}>
          <Box sx={{ height: "100%" }}>
            <InputGroup>
              <InputRightElement
                h="100%"
                cursor={"pointer"}
                onClick={() => handleSearchData("name")}
              >
                <MdSearch color={theme.colors.secondary.main} size={20} />
              </InputRightElement>
              <Input
                variant={"outline"}
                placeholder="Search by name"
                sx={{
                  height: "100%",
                }}
                borderColor={theme.colors.secondary.main}
                onChange={(e) => {
                  if (e.target.value !== "") {
                    setSearchName(e.target.value);
                  } else {
                    setResearchData(`again_${Math.random()}`);
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleSearchData("name");
                  }
                }}
              />
            </InputGroup>
          </Box>

          <Box sx={{ height: "100%" }}>
            <InputGroup>
              <InputRightElement
                h="100%"
                cursor={"pointer"}
                onClick={() => handleSearchData("mobile")}
              >
                <MdSearch color={theme.colors.secondary.main} size={20} />
              </InputRightElement>
              <Input
                variant={"outline"}
                placeholder="Search by number"
                sx={{
                  height: "100%",
                }}
                borderColor={theme.colors.secondary.main}
                onChange={(e) => {
                  if (e.target.value !== "") {
                    setSearchMobile(e.target.value);
                  } else {
                    setResearchData(`again_${Math.random()}`);
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleSearchData("mobile");
                  }
                }}
              />
            </InputGroup>
          </Box>
        </Flex>

        <Flex sx={{ marginRight: "3vw" }}>
          <Text
            sx={{
              fontSize: theme.fontSizes.body,
              marginRight: "0.25rem",
            }}
          >
            Total Blocked Drivers:
          </Text>
          <Skeleton isLoaded={!isDataFetching}>
            <Text
              sx={{
                fontSize: theme.fontSizes.body,
                color: "green",
              }}
            >
              {totalDrivers}
            </Text>
          </Skeleton>
        </Flex>
      </Flex>

      <Box sx={{ marginTop: "1rem", paddingX: "2rem" }}>
        <Skeleton isLoaded={isDataFetching ? false : true} minHeight={"20rem"}>
          {allDrivers.length !== 0 ? (
            <Skeleton isLoaded={allDrivers ? true : false}>
              <ViewersTable
                data={allDrivers}
                theme={theme}
                setUserFetchName={() => {
                  setResearchData(`research${Math.random()}`);
                }}
              />
            </Skeleton>
          ) : (
            <Text>No blocked drivers found!</Text>
          )}
        </Skeleton>
        <Box
          sx={{
            marginTop: theme.space.xl,
          }}
        >
          <Flex
            sx={{
              justifyContent: "flex-end",
              alignItems: "center",
              gap: "3rem",
            }}
          >
            <Box>
              <Flex
                sx={{
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "0.5rem",
                }}
              >
                <Flex
                  sx={{
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "50%",
                    width: "2rem",
                    height: "2rem",
                  }}
                >
                  <Icon
                    as={MdArrowBackIosNew}
                    boxSize={5}
                    color={theme.colors.primary.main}
                    cursor={pageNumber !== 1 ? "pointer" : "not-allowed"}
                    onClick={() => {
                      if (pageNumber !== 1) {
                        setPageNumber(pageNumber - 1);
                        localStorage.setItem(
                          "blockedpage",
                          `${pageNumber - 1}`,
                        );
                        setRefetchUrl(
                          `/drivers?blocked=true&page=${pageNumber - 1}`,
                        );
                      }
                    }}
                  />
                </Flex>
                <Text variant={"caption"}>Previous Page</Text>
              </Flex>
            </Box>
            <Skeleton
              isLoaded={isDataFetching ? false : true}
              sx={{ width: "2rem" }}
            >
              <Text variant={"body"}>{pageNumber}</Text>
            </Skeleton>
            <Box>
              <Flex
                sx={{
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "0.5rem",
                }}
              >
                <Text variant={"caption"}>Next Page</Text>
                <Flex
                  sx={{
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "50%",
                    width: "2rem",
                    height: "2rem",
                  }}
                >
                  <Icon
                    as={MdArrowForwardIos}
                    boxSize={5}
                    color={theme.colors.primary.main}
                    cursor={nextNotAllowed ? "not-allowed" : "pointer"}
                    onClick={() => {
                      if (!nextNotAllowed) {
                        setPageNumber(pageNumber + 1);
                        localStorage.setItem(
                          "blockedpage",
                          `${pageNumber + 1}`,
                        );
                        setRefetchUrl(
                          `/drivers?blocked=true&page=${pageNumber + 1}`,
                        );
                      }
                    }}
                  />
                </Flex>
              </Flex>
            </Box>
          </Flex>
        </Box>
      </Box>
    </Box>
  );
}

export default Blocked;

type ViewerstableType = {
  data?: any;
  theme: Theme;
  setUserFetchName: () => void;
};

function ViewersTable({ data, theme, setUserFetchName }: ViewerstableType) {
  const axios = getAxios();
  const toast = useToast();
  const access_token = Cookies.get("x-admin-auth");
  const [unblockedLoading, setUnBlockedLoading] = React.useState(false);
  const [deleteLoading, setDeleteLoading] = React.useState(false);
  React.useState(false);
  const [modalId, setModalId] = React.useState<string>();
  const {
    isOpen: isUnblockOpen,
    onOpen: onUnblockOpen,
    onClose: onUnblockClose,
  } = useDisclosure();
  const {
    isOpen: isDeleteOpen,
    onOpen: onDeleteOpen,
    onClose: onDeleteClose,
  } = useDisclosure();

  async function handleUnblockButton(id: string) {
    setUnBlockedLoading(true);
    try {
      const res = await axios.get(`/drivers/${id}/unblock`, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });
      onUnblockClose();
      setUserFetchName();
      return toast({
        position: "top",
        title: "Driver unblocked.",
        description: (
          <Text variant={"caption"} color="white">
            Changes were successfully reflected
          </Text>
        ),
        status: "success",
        duration: 5000,
        isClosable: true,
      });
    } catch (error) {
      console.log("error unblocking", error);
    } finally {
      setUnBlockedLoading(false);
    }
  }

  async function handleDeleteButton(id: string) {
    setDeleteLoading(true);
    try {
      const res = await axios.delete(`/drivers/${id}`, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });
      onDeleteClose();
      setUserFetchName();
      return toast({
        position: "top",
        title: "Driver deleted.",
        description: (
          <Text variant={"caption"} color="white">
            Changes were successfully reflected
          </Text>
        ),
        status: "success",
        duration: 5000,
        isClosable: true,
      });
    } catch (error) {
      console.log("error while deleting", error);
    } finally {
      setDeleteLoading(false);
    }
  }

  return (
    <>
      <table>
        <thead>
          <tr>
            <th>
              <Text
                sx={{
                  fontSize: theme.fontSizes.subHeading2,
                }}
              >
                Vehicle Reg. No.
              </Text>
            </th>
            <th>
              <Text
                sx={{
                  fontSize: theme.fontSizes.subHeading2,
                }}
              >
                Name
              </Text>
            </th>
            <th>
              <Text
                sx={{
                  fontSize: theme.fontSizes.subHeading2,
                }}
              >
                Mobile
              </Text>
            </th>
            <th>
              <Text
                sx={{
                  fontSize: theme.fontSizes.subHeading2,
                }}
              >
                Block Status
              </Text>
            </th>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {data.map((item: any, index: number) => (
            <tr key={index}>
              <td>
                <Text
                  sx={{
                    fontSize: theme.fontSizes.subHeading2,
                  }}
                >
                  {item.vehicle_details?.registration_number || "N/A"}
                </Text>
              </td>
              <td>
                <Text
                  sx={{
                    fontSize: theme.fontSizes.subHeading2,
                  }}
                >
                  {item.name}
                </Text>
              </td>
              <td>
                <Text
                  sx={{
                    fontSize: theme.fontSizes.subHeading2,
                  }}
                >
                  {item.mobile}
                </Text>
              </td>
              <td>
                <Text
                  sx={{
                    fontSize: theme.fontSizes.subHeading2,
                  }}
                >
                  {item.is_blocked ? "Blocked" : "Active"}
                </Text>
              </td>
              <td>
                <Flex
                  sx={{
                    justifyContent: "center",
                    alignItems: "center",
                    height: "2.8rem",
                    borderRadius: "0.25rem",
                  }}
                >
                  <Button
                    width="100%"
                    height="3rem"
                    rightIcon={<FaArrowRight />}
                    onClick={() => {
                      onUnblockOpen();
                      setModalId(item.id);
                    }}
                    style={{
                      background: theme.colors.primary.main,
                      color: theme.colors.bg.main,
                    }}
                  >
                    <Text sx={{ fontSize: theme.fontSizes.body }}>
                      {"Unblock"}
                    </Text>
                  </Button>
                </Flex>
              </td>
              <td>
                <Flex
                  sx={{
                    justifyContent: "center",
                    alignItems: "center",
                    height: "2.8rem",
                    borderRadius: "0.25rem",
                  }}
                >
                  <Button
                    width="100%"
                    height="3rem"
                    rightIcon={<FaTrash />}
                    onClick={() => {
                      onDeleteOpen();
                      setModalId(item.id);
                    }}
                    style={{
                      borderWidth: "1px",
                      borderStyle: "solid",
                      borderColor: theme.colors.primary.main,
                      color: theme.colors.primary.main,
                    }}
                  >
                    <Text sx={{ fontSize: theme.fontSizes.body }}>
                      {"Delete"}
                    </Text>
                  </Button>
                </Flex>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <UnBlockedModal
        id={modalId}
        onClose={onUnblockClose}
        isOpen={isUnblockOpen}
        unblockedLoading={unblockedLoading}
        handleUnblockButton={handleUnblockButton}
      />
      <DeleteModal
        id={modalId}
        onClose={onDeleteClose}
        isOpen={isDeleteOpen}
        deleteLoading={deleteLoading}
        handleDeleteButton={handleDeleteButton}
      />
    </>
  );
}

function UnBlockedModal({
  id,
  isOpen,
  onClose,
  handleUnblockButton,
  unblockedLoading,
}: any) {
  const theme = useTheme<Theme>();
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      closeOnOverlayClick={true}
      isCentered={true}
      size="md"
      returnFocusOnClose={false}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton
          sx={{
            borderRadius: "50%",
            background: "transparent",
            top: "5%",
            left: "93%",
            transform: "translate(-100%)",
            width: "3rem",
            height: "3rem",
            color: theme.colors.primary.main,
            //@ts-ignore
            "&:hover": {
              background: "transparent",
            },
          }}
        />
        <ModalBody sx={{ borderRadius: "0.25rem" }}>
          <Box sx={{ margin: "6rem 1.5rem 2.5rem 1.5rem" }}>
            <Box mb={theme.space.xl}>
              <Text variant={"subHeading1"}>
                Are you sure you want to unblock the driver?
              </Text>
            </Box>
            <Box>
              <Button
                w="100%"
                h="3em"
                color={theme.colors.primary.main}
                bg="white"
                border={"1px solid"}
                borderColor={theme.colors.primary.main}
                borderRadius={"4px"}
                _hover={{ bg: theme.colors.primary.main, color: "white" }}
                isLoading={unblockedLoading}
                variant="solid"
                size="contain"
                onClick={() => {
                  handleUnblockButton(id as string);
                }}
              >
                Unblock Driver
              </Button>
            </Box>
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

function DeleteModal({
  id,
  isOpen,
  onClose,
  handleDeleteButton,
  deleteLoading,
}: any) {
  const theme = useTheme<Theme>();
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      closeOnOverlayClick={true}
      isCentered={true}
      size="md"
      returnFocusOnClose={false}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton
          sx={{
            borderRadius: "50%",
            background: "transparent",
            top: "5%",
            left: "93%",
            transform: "translate(-100%)",
            width: "3rem",
            height: "3rem",
            color: theme.colors.primary.main,
            //@ts-ignore
            "&:hover": {
              background: "transparent",
            },
          }}
        />
        <ModalBody sx={{ borderRadius: "0.25rem" }}>
          <Box sx={{ margin: "6rem 1.5rem 2.5rem 1.5rem" }}>
            <Box mb={theme.space.xl}>
              <Text variant={"subHeading1"}>
                Are you sure you want to delete the driver?
              </Text>
            </Box>
            <Box>
              <Button
                w="100%"
                h="3em"
                color={theme.colors.primary.main}
                bg="white"
                border={"1px solid"}
                borderColor={theme.colors.primary.main}
                borderRadius={"4px"}
                _hover={{ bg: theme.colors.primary.main, color: "white" }}
                isLoading={deleteLoading}
                variant="solid"
                size="contain"
                onClick={() => {
                  handleDeleteButton(id as string);
                }}
              >
                Delete
              </Button>
            </Box>
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
